// extracted by mini-css-extract-plugin
export default {"noProducts":"no-products_noProducts__ywch-","lead":"no-products_lead__3AGLv","link":"no-products_link__pdprL","main":"no-products_main__vEUhb"};